export default __webpack_public_path__ + "static/media/(60).cfac1903.jpg";